module.exports = __webpack_public_path__ + "img/google-sign-in.4cb6a571.svg";